import { FC } from "react";

import { IRideTableDto, RideDelayStatusEnum } from "@ryde/shared";

import { LiveMapDelayStatusBadge } from "../../grid/cell-templates/rides/live-map-delay-status-badge";
import { IRenderColumnTemplate } from "./_core";

export const LiveMapDelayStatusCellTemplate: FC<IRenderColumnTemplate> = ({
  rowOriginal,
  value,
}) => {
  const ride = rowOriginal as IRideTableDto | undefined;
  const status =
    (value as RideDelayStatusEnum | undefined) ?? ride?.statusLate ?? undefined;

  return <LiveMapDelayStatusBadge status={status} />;
};
